import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/trade.png'
import _imports_1 from '@/assets/images/trade@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "step" }
const _hoisted_3 = {
  key: 0,
  class: "tips"
}
const _hoisted_4 = {
  key: 1,
  class: "tips"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_transfer_item = _resolveComponent("transfer-item")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 3,
    prePathName: "bind-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          srcset: _hoisted_1,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", null, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createTextVNode("请转账至金马证券银行账户 "),
            _createElementVNode("span", null, "2/3")
          ], -1)),
          (_ctx.formType === _ctx.FormType.OPEN_ACCOUNT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "单笔转账金额需不低于10,000港币或1,500美元"))
            : _createCommentVNode("", true),
          (_ctx.formType === _ctx.FormType.OPEN_IMMIGRANT_ACCOUNT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "单笔金额不低于10,000港币或1,500美元"))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", null, " 请根据您的情况，选择以下任一银行进行转账 ", -1)),
      _createVNode(_component_transfer_item, { step: 0 }),
      _createVNode(_component_transfer_item, {
        step: 1,
        stepTitle: "转入美元"
      })
    ]),
    _: 1
  }, 8, ["onHandleNext"]))
}